/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Type_Eclypserelais1Inputs */



/**
* | output |
* | --- |
* | "Dalkia relay" |
*
* @param {Module_Type_Eclypserelais1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const module_type_eclypserelais1 = /** @type {((inputs?: Module_Type_Eclypserelais1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Type_Eclypserelais1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Dalkia relay")
	return /** @type {LocalizedString} */ ("Relais Dalkia")
});
export { module_type_eclypserelais1 as "module_type_eclypseRelais" }